import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IOrderTemplateRepository } from '@/coreInfrastructureModule/interfaces/IOrderTemplateRepository';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { OrderTemplateDownloadUrl } from '../domains/valueObjects/presignedUrl';
import { OrderTemplateAdapter } from '../adapters/orderTemplateAdapter';

/**
 * 発注テンプレートのダウンロード用URLを取得するユースケース
 */
export class GetOrderTemplateDownloadUrlUseCase {
  /**
   * コンストラクタ
   * @param repository - PresignedダウンロードURLを取得するリポジトリ
   */
  constructor(private readonly repository: IOrderTemplateRepository) {}

  /**
   * ダウンロード用URLを取得する
   * @param templateId - テンプレートID
   */
  public Execute = async (templateId: string): Promise<INetworkResult<OrderTemplateDownloadUrl, IError>> => {
    const result = await this.repository.getDownloadUrl(templateId);
    if (result.status.type === 'success') {
      return {
        status: {
          type: 'success',
          data: OrderTemplateAdapter.toDownloadUrl(result.status.data),
        },
      };
    }

    return { status: result.status };
  };
}
